export const grey = '#f0f0f0';
export const darkGrey = '#686868';
export const almostBlack = '#282828';
export const green = '#00a050';
export const red = '#ff7463';
export const darkRed = '#ff5440';

// export const boxShadow = '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)';
// export const hoverBoxShadow = '0 6px 12px rgba(0,0,0,0.16), 0 6px 12px rgba(0,0,0,0.23)';

export const boxShadow = '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)';
export const hoverBoxShadow = '0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)';
export const outlineAsBoxShadow = `inset 0px 0px 0px 2px ${green}`;

export const qaLink = 'https://docs.google.com/document/d/1djICeNhxCcH2sw30XrgQVZgrgmHKU-yupLkixtr0UEE/edit?usp=sharing'